import './App.css';
import { Header, About, Services, Contact, Footer } from './components';

function App() {
  return (
    <div className="App">
      <Header />
      <About />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
